import React from 'react'
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import * as auth from "../modules/Auth/_redux/authRedux";
import { getPageFilters } from "../util/helpers";

export function isNumber(value) {
  const number = Number(value);
  return !isNaN(number);
}

export function formatTimeItem(value) {
  return `${value || ""}00`.substr(0, 2);
}

export const TimeInput = (props) => {
  const [min, setMin] = useState(props.min);
  const [sec, setSec] = useState(props.sec);
  const [minErr, setMinErr] = useState(false);
  const [secErr, setSecErr] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setMin(props.min);
    setSec(props.sec);
  }, [props]);

  const handleMinChange = (e) => {
    let val = e.target.value;
    setMin(val);
    if (!val || val === "") {
      setMinErr(false);
      dispatchChange(val, sec);
      return;
    }
    if (!isNumber(val)) {
      setMinErr(true);
    } else {
      setMinErr(false);
    }
    dispatchChange(val, sec);
  };

  const handleSecChange = (e) => {
    let val = e.target.value;
    setSec(val);
    if (!val || val === "") {
      setSecErr(false);
      dispatchChange(min, val);
      return;
    }

    if (!isNumber(val)) {
      setSecErr(true);
    } else {
      setSecErr(false);
    }
    dispatchChange(min, val);
  };

  const dispatchChange = (m, s) => {
    let pageFilters = getPageFilters();
    pageFilters = { ...pageFilters };
    var changelog = {};
    changelog[props.minKey] = m;
    changelog[props.secKey] = s;
    pageFilters["changelog"] = changelog;

    const action = {
      type: auth.actionTypes.Set,
      payload: { ...pageFilters },
    };
    dispatch(action);
    dispatch(
      auth.actions.CheckFiltersState({
        apply: true,
        filter_type: "callLogsFiltersState",
      })
    );
  };

  const blockInvalidChar = (e) =>
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();

  return (
    <div className="min-sec-container ml-5ddd mt-1 ">
      <input
        className={`min-sec-input-field ${minErr ? "invalid-m" : ""}`}
        type="number"
        maxLength={3}
        min={0}
        name="minutes"
        placeholder="MIN"
        onChange={handleMinChange}
        onKeyPress={blockInvalidChar}
        value={min}
      />

      <span className="dots pr-2 pl-2 text-dark">:</span>
      <input
        className={`min-sec-input-field-2 ${secErr ? "invalid-s" : "valid-s"}`}
        type="number"
        name="second"
        maxLength={3}
        min={0}
        placeholder="SEC"
        onChange={handleSecChange}
        onKeyPress={blockInvalidChar}
        value={sec}
      />
    </div>
  );
};
